import { NavLink, useParams } from 'react-router-dom';

import { Breadcrumb, Button, PageTitle, PageWrapper } from '@ingrid/luterkort-react';

import { RoleGuard } from '~src/components/RoleGuard/RoleGuard';
import { useTranslation } from '~src/i18n/use-translation';
import { AppRoute } from '~src/main/routes';
import { useShipmentsListQuery } from '~src/pages/shipment/queries';
import { Format } from '~src/utils/format';

import { useTransportOrderDetailsSuspenseQuery } from '../queries';
import { Addresses, getTransportOrderAddresses } from './addresses';
import { CarrierAndTransportProduct } from './carrier-and-transport-product';
import { Details } from './details';
import { OrderDetails } from './order-details';
import { OrderInformation } from './order-information';
import { Shipments } from './shipments';

export function Page() {
  const { t } = useTranslation();
  const { orderId } = useParams();

  const { data: order } = useTransportOrderDetailsSuspenseQuery({ id: orderId });
  const { data: shipments = [] } = useShipmentsListQuery({ tos_id: orderId });

  if (!order) {
    return null;
  }

  return (
    <PageWrapper variant="center">
      <PageTitle.Wrapper style={{ flexWrap: 'wrap' }}>
        <PageTitle.Stack>
          <Breadcrumb aria-label={t('common.breadcrumbs')}>
            <NavLink to="..">{t('common.order')}</NavLink>
            <a aria-current="page">{Format.Id(order.id!)}</a>
          </Breadcrumb>
        </PageTitle.Stack>

        <RoleGuard roles={['transport:edit']} withTooltip>
          <Button as={NavLink} to={`${AppRoute.SHIPMENTS_CREATE}`}>
            {t('common.createShipment')}
          </Button>
        </RoleGuard>
      </PageTitle.Wrapper>

      <OrderInformation external={order?.external} id={order.id} metadata={order.metadata} />
      <Addresses addresses={getTransportOrderAddresses(order)} />
      <OrderDetails cart={order.cart} />
      <CarrierAndTransportProduct metadata={order.metadata} />
      <Shipments shipments={shipments} />
      <Details order={order} />
    </PageWrapper>
  );
}
